import classnames from "classnames";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

const TopicsCards = (props) => {
  const { news, activeView, t } = props;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const { webmasterTitle } = useRouteMatch().params;

  const renderData = () => {
    if (news.data?.length) {
      return news?.data?.map((item, i) => {
        return (
          <Card
            className="ecommerce-card0"
            style={{ gridTemplateColumns: "1fr 2fr" }}
            key={i}
          >
            <div className="item-img text-center mx-auto">
              <Link to={`/emission/${item.id}`}>
                <img
                  width="100%"
                  height="100%"
                  className="img-fluid card-img-top"
                  src={item.photo_file && item.photo_file}
                  alt={item.name}
                />
              </Link>
            </div>

            <CardBody>
              <div className="blog-overlay-smartEnd">
                <p>
                  {new Date(item.date).toLocaleString(`${lang1}-US`, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <div className="mail-body">
                  <div className="mail-message">
                    <h3 className="text-truncate mb-0">{item.title}</h3>
                  </div>
                </div>
                <Link
                  className="btn btn-outline"
                  to={`/dataNews/${webmasterTitle}/topics/${item.id}`}
                >
                  {t("read more")}
                </Link>
              </div>
            </CardBody>
          </Card>
        );
      });
    }
  };

  return (
    <div
      className={classnames({
        "grid-view": activeView === "grid",
        "list-view": activeView === "list",
      })}
    >
      {renderData()}
    </div>
  );
};

export default TopicsCards;
